/**
 * Hekim Analiz Puanlama Modalı — minimal yayın/abonelik deposu.
 *
 * Global axios response interceptor (AxiosConfig.js), başarılı bir onay/revizyon
 * cevabında `show_rating_modal === true` gördüğünde `openRatingModal` çağırır.
 * App root'una mount edilen tek <RatingModal/> bu depoyu dinler.
 *
 * - Tek bir modal instance olduğu için aynı cevabın iki kez işlenmesi yine tek modal açar.
 * - Sayfa yenilendiğinde hiçbir API aksiyonu olmayacağı için modal kendiliğinden açılmaz.
 */

let listeners = [];
let state = { open: false, analysisPk: null, reasons: [] };

const notify = () => {
    listeners.forEach((listener) => listener(state));
};

export const openRatingModal = (analysisPk, reasons = []) => {
    state = { open: true, analysisPk, reasons };
    notify();
};

export const closeRatingModal = () => {
    state = { open: false, analysisPk: null, reasons: [] };
    notify();
};

export const subscribeRatingModal = (listener) => {
    listeners.push(listener);
    return () => {
        listeners = listeners.filter((item) => item !== listener);
    };
};

export const getRatingModalState = () => state;
